const selector = {
    checkoutForm: '#form_checkout',
    checkTerms: '#check_terms',
    serialNumber: '#tag_serial_number',
    registrationPlate: '#registration_plate',
    btn: {
        submit: '#btn_submit'
    },
    form: {
        customerType: 'input[name="customer_type"]',
        customerTypeChecked: 'input[name="customer_type"]:checked',
        customer: {
            cardholderName: '#cardholder_name',
            cardholderSurname: '#cardholder_surname',
        },
        business: {
            companyName: '#company_name',
            mb: '#mb',
        },
    },
};

export {selector};